import { render, staticRenderFns } from "./ReferencesTypes.vue?vue&type=template&id=40142a23&"
import script from "./ReferencesTypes.vue?vue&type=script&lang=js&"
export * from "./ReferencesTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports